import React from 'react'

const Option = ({ id, name }) =>
  <option value={id}>{name}</option>

export default Option


// WEBPACK FOOTER //
// ./src/modules/BranchSelect/Option/Option.js